import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { LoadingIndicatorService } from './core/services/loading-indicator.service';
import { TokenRefreshScheduler } from './core/services/token-refresh-scheduler.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly loading = inject(LoadingIndicatorService);

  private readonly tokenRefreshScheduler = inject(TokenRefreshScheduler);
}
